export default __webpack_public_path__ + "static/media/354.61ba49d3.png";